import React, { useCallback, useEffect, useState } from 'react';
import { axiosInstance as axios } from '../../../context/AuthContext';
import { PilotSettingsCard } from './PilotSettingsCard';
import { PilotProsCard } from './PilotProsCard';
import { PilotPresentationsCard } from './PilotPresentationsCard';
import { PilotResultsCard } from './PilotResultsCard';

export default function PilotTab() {
  const [pros, setPros] = useState([]);
  const [results, setResults] = useState(null);

  const load = useCallback(async () => {
    const [p, r] = await Promise.all([
      axios.get('/api/pilot/admin/professionals'),
      axios.get('/api/pilot/admin/results'),
    ]);
    setPros(p.data);
    setResults(r.data);
  }, []);

  useEffect(() => { load().catch(() => {}); }, [load]);

  return (
    <div className="space-y-6" data-testid="pilot-tab">
      <div className="bg-gradient-to-r from-emerald-900/60 to-slate-800 border border-emerald-700/40 rounded-xl p-5">
        <h2 className="text-xl font-bold text-white">Founding Pilot</h2>
        <p className="text-slate-300 text-sm mt-1">
          Phase 1: invite professionals to explore and give feedback. Phase 2: open it to families when you're ready.
        </p>
      </div>
      <PilotProsCard pros={pros} onChanged={load} />
      <PilotSettingsCard />
      <PilotPresentationsCard pros={pros} presentations={results?.presentations || []} onChanged={load} />
      <PilotResultsCard results={results} />
    </div>
  );
}
